import { ptBR } from '@/i18n/pt-BR';
import type { AdminErrorReason } from '@/lib/plataforma_admin';

/**
 * Motivo estável do cliente → frase do catálogo. // ux-neutrality:allow doc-comment
 *
 * A régua que vale é a do servidor: cada recusa tem código próprio, e a tela // ux-neutrality:allow doc-comment
 * mostra a razão exata em vez de um genérico "não foi possível". Um mapa (e não // ux-neutrality:allow doc-comment
 * uma cadeia de condições) para que acrescentar uma razão seja uma linha, e não // ux-neutrality:allow doc-comment
 * um ramo a mais numa função que já cresceu demais. // ux-neutrality:allow doc-comment
 */
const _FRASES: Partial<Record<AdminErrorReason, string>> = {
  escritorio_com_casos: ptBR.admin.erroEscritorioComCasos,
  desvinculo_ambiguo: ptBR.admin.erroDesvinculoAmbiguo,
  plataforma_nao_tem_cliente: ptBR.admin.erroPlataformaNaoTemCliente,
  ultima_plataforma: ptBR.admin.erroUltimaPlataforma,
  plataforma_nao_encerra: ptBR.admin.erroPlataformaNaoEncerra,
  escritorio_encerrado: ptBR.admin.erroEscritorioEncerrado,
  ultimo_gestor: ptBR.admin.erroUltimoGestor,
  acao_sobre_si_mesmo: ptBR.admin.erroAcaoSobreSiMesmo,
  papel_fora_do_ambiente: ptBR.admin.erroPapelForaDoAmbiente,
  email_ja_cadastrado: ptBR.admin.erroEmailJaCadastrado,
  not_found: ptBR.admin.erroNaoEncontrado,
  unauthorized: ptBR.admin.erroSemAcesso,
  network: ptBR.admin.erroRede,
  export_muito_grande: ptBR.admin.erroExportMuitoGrande,
};

export function mapAdminError(reason: AdminErrorReason): string {
  return _FRASES[reason] ?? ptBR.admin.erroGenerico;
}
